import { Textarea } from '@/components/form';
import { errorFieldMessage } from '@/const';
import clsx from 'clsx';
import * as React from 'react';
import {
	FieldErrors,
	FieldValues,
	UseFormGetValues,
	UseFormRegister,
} from 'react-hook-form';

interface QuestionHeaderI {
	index: number;
	isEditModeActived: boolean;
	register: UseFormRegister<FieldValues>;
	getValues: UseFormGetValues<FieldValues>;
	errors: FieldErrors<FieldValues>;
	classNameContainerInput?: string;
}

export const QuestionHeader: React.FC<QuestionHeaderI> = ({
	index,
	isEditModeActived,
	register,
	getValues,
	errors,
	classNameContainerInput = '',
}) => {
	const textareaRef = React.useRef<HTMLTextAreaElement | null>(null);
	const rules = {
		question: {
			required: { value: true, message: errorFieldMessage },
		},
	};
	const resizeToContent = () => {
		if (textareaRef.current) {
			textareaRef.current.style.height = 'auto';
			textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
		}
	};

	React.useEffect(() => {
		if (!isEditModeActived) {
			// Only resize when leaving edit mode
			resizeToContent();
		}
	}, [isEditModeActived]);
	return (
		<div
			className={clsx(
				'flex items-center mb-6',
				!isEditModeActived && !!getValues(`questions[${index}].question`)
					? 'gap-x-1'
					: 'gap-x-4'
			)}
		>
			<Textarea
				register={register}
				name={`questions[${index}].question`}
				id={`questions[${index}].question`}
				placeholder="Question"
				classNameInput={clsx(
					'w-full font-semibold placeholder:font-normal 2xl:!text-base !mt-0 !placeholder-opacity-black',
					{
						'!px-1':
							!isEditModeActived && !!getValues(`questions[${index}].question`),
					}
				)}
				className="w-full"
				classNameContainerInput={clsx(
					'rounded-lg pr-1',
					classNameContainerInput,
					{
						'border-none':
							getValues(`questions[${index}].question`) || isEditModeActived,
					}
				)}
				rules={rules.question}
				error={(errors?.questions as any)?.[index]?.question}
				resizable
				rows={1}
				textAreaRef={textareaRef}
			/>
		</div>
	);
};
